module.exports = __webpack_public_path__ + "static/media/icon_add_patient_checkbox.842e2ad8.svg";